
import {BaseModel} from '../base';

class JRNIAppModel extends BaseModel {
    constructor(data) {
        super(data);

        this.setupScripts();

    }


    setupScripts(){
        if (this._data && this._data.script_packs){
          this._data.script_packs.forEach( (pack) => {
            pack.scripts.forEach( (script) => {
              if (script.type == "PublicScript" && !this[script.name]){
                this[script.name] = function (data) {
                    return this.$callScriptFunction(script, data);
                };

              }
            })
          });
        } 
    }

    // call a script function
    $callScriptFunction(script, data){
      let type = 'public_script';
      if (script.type == 'AdminScript'){
        type = 'admin_script'
      }
      // call a function, try, in order, POST, PUT, GET then DELETE
      if (script.actions.includes('Post')){
        return this.$post(type, {name: script.name, no_cache: true}, data);
      } else if (script.actions.includes('Put')){
        return this.$put(type, {name: script.name, no_cache: true}, data);
      } else if (script.actions.includes('Get')){
        return this.$get(type, {name: script.name, no_cache: true}, data);
      } else if (script.actions.includes('Del')){
        return this.$del(type, {name: script.name, no_cache: true}, data);
      }
      return Promise.reject("Script not valid")
    }
}

export {
    JRNIAppModel
};
